
export const ADD_THOUGHT_LEADER = "ADD_THOUGHT_LEADER";
export const UPDATE_THOUGHT_LEADER = "UPDATE_THOUGHT_LEADER";
export const DELETE_THOUGHT_LEADER = "DELETE_THOUGHT_LEADER";
export const SET_THOUGHT_LEADER = "SET_THOUGHT_LEADER";
export const CHANGE_STATUS = "CHANGE_STATUS";